import React, { Component } from 'react';
var $ = require('jquery');

export default class Header extends Component{

  constructor(props){
    super(props);
    this.goToSection = this.goToSection.bind(this);
  }

  goToSection(section){
    var windowWidth = window.innerWidth;
    $("body").animate({ "marginLeft": (windowWidth * ((-section) + 1))}, 500);
    $('header ul li').removeClass('active');
    $('header ul li:nth-of-type(' + section + ')').addClass('active');
    setTimeout(function(){
      $('.section-' + section + ' .section-content').addClass('activeSection');
    }, 500);
  }
  render(){
    return(
      <header>
        <ul>
          <li data-section="1" onClick={() => this.goToSection(1)}>Menu</li>
          <li data-section="2" onClick={() => this.goToSection(2)}>About</li>
          <li data-section="3" onClick={() => this.goToSection(3)}>Reviews</li>
          <li data-section="4" onClick={() => this.goToSection(4)}>Contact</li>
        </ul>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/header.jsx